import * as React from 'react';
import { BulkEditForm } from './BulkEditForm';
import { useSelectedEntries } from 'general-ledger/fast-gl/hooks/useSelectedEntries';

export const BulkEditFormContainer = () => {
  const { selectedDataEntries, selectedLedgerAccountIds } = useSelectedEntries();

  if (!selectedDataEntries.size && !selectedLedgerAccountIds.size) return null;

  return <BulkEditForm />;
};
